<div class="flex-row border-bottom-4-red printable">
    <div class="flex-row-item">
        <span class="title">{{ 'D2' | translate : locale }}</span>
    </div>

    <div class="flex-row-item">
        <div class="flex-row flex-row-item-align-center cpa cpa-code" (click)="onOpenCpaAccountsDialog()">
            {{ cpaCode }}
        </div>
        <div class="flex-row flex-row-item-align-center" *ngIf="country && cpaName">
            <img class="flag" src="./assets/flags/{{ country }}.png" alt="{{country}} flag">
            <span class="cpa cpa-name" [title]="cpaName">{{ cpaName }}</span>
        </div>
        <div class="product-group-container margin-left-1" *ngIf="productGroups">
            <ng-select class="product-groups" (change)="onChange()" [clearable]="false" [items]="productGroups"
                [readonly]="productGroups.length === 1" [searchable]="false" [(ngModel)]="selectedProductGroup">
            </ng-select>
        </div>
        <div class="print-button">
            <button (click)="print()">{{ 'D4' | translate : locale }}</button>
        </div>
    </div>
</div>